/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_GS_71_83 as Componente_GS_71_83,
  rec_Componente_HS_72_83 as Componente_HS_72_83,
  rec_JSXRuntime as JSXRuntime,
  rec_Qx as Qx,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_US as US,
  rec_WS as WS,
  rec_Yx as Yx,
  rec_fS as fS,
  rec_pS as pS,
} from "../../runtime/index.jsx";
export function ResumenTarea(e) {
  let t = (0, ReactCompiler.c)(78),
    { tarea: n, comprobantes: r, metas: i, listas: a } = e,
    o;
  if (t[0] !== i || t[1] !== n.metaId) {
    let e;
    (t[3] === n.metaId
      ? (e = t[4])
      : ((e = (e) => String(e.id) === String(n.metaId)),
        (t[3] = n.metaId),
        (t[4] = e)),
      (o = i.find(e)),
      (t[0] = i),
      (t[1] = n.metaId),
      (t[2] = o));
  } else o = t[2];
  let s = o,
    c;
  if (t[5] !== a || t[6] !== n.listaId) {
    let e;
    (t[8] === n.listaId
      ? (e = t[9])
      : ((e = (e) => String(e.id) === String(n.listaId)),
        (t[8] = n.listaId),
        (t[9] = e)),
      (c = a.find(e)),
      (t[5] = a),
      (t[6] = n.listaId),
      (t[7] = c));
  } else c = t[7];
  let l = c,
    u;
  t[10] === n.checklist
    ? (u = t[11])
    : ((u = n.checklist ?? []), (t[10] = n.checklist), (t[11] = u));
  let d;
  t[12] === u ? (d = t[13]) : ((d = u.filter(WS)), (t[12] = u), (t[13] = d));
  let f = d.length,
    p;
  t[14] === n.checklist
    ? (p = t[15])
    : ((p = n.checklist ?? []), (t[14] = n.checklist), (t[15] = p));
  let m = p.length,
    h;
  t[16] === n.estado
    ? (h = t[17])
    : ((h = Qx(n.estado)), (t[16] = n.estado), (t[17] = h));
  let _ = `rounded-full px-2 py-0.5 text-[11px] ${h}`,
    v;
  t[18] === n.estado
    ? (v = t[19])
    : ((v = Yx(n.estado)), (t[18] = n.estado), (t[19] = v));
  let y;
  t[20] !== _ || t[21] !== v
    ? ((y = <span className={_} children={v} />),
      (t[20] = _),
      (t[21] = v),
      (t[22] = y))
    : (y = t[22]);
  let b;
  t[23] === n.prioridad
    ? (b = t[24])
    : ((b = Yx(n.prioridad)), (t[23] = n.prioridad), (t[24] = b));
  let x;
  t[25] === b
    ? (x = t[26])
    : ((x = (
        <span
          className={`rounded-full bg-(--panel) px-2 py-0.5 text-[11px] text-(--text)`}
          children={b}
        />
      )),
      (t[25] = b),
      (t[26] = x));
  let S;
  t[27] === n.atrasada
    ? (S = t[28])
    : ((S = n.atrasada && (
        <span
          className={`rounded-full bg-(--error-bg) px-2 py-0.5 text-[11px] text-(--error)`}
          children={`Atrasada`}
        />
      )),
      (t[27] = n.atrasada),
      (t[28] = S));
  let C;
  t[29] !== x || t[30] !== S || t[31] !== y
    ? ((C = (
        <div
          className={`flex flex-wrap items-center gap-1.5`}
          children={[y, x, S]}
        />
      )),
      (t[29] = x),
      (t[30] = S),
      (t[31] = y),
      (t[32] = C))
    : (C = t[32]);
  let w;
  t[33] === n.titulo
    ? (w = t[34])
    : ((w = (
        <h3
          className={`text-base font-medium text-(--text-h)`}
          children={n.titulo}
        />
      )),
      (t[33] = n.titulo),
      (t[34] = w));
  let T;
  t[35] === n.descripcion
    ? (T = t[36])
    : ((T = n.descripcion && (
        <p
          className={`whitespace-pre-wrap text-(--text)`}
          children={n.descripcion}
        />
      )),
      (t[35] = n.descripcion),
      (t[36] = T));
  let E = n.creadoPorNombre || `—`,
    D;
  t[37] === E
    ? (D = t[38])
    : ((D = <Componente_GS_71_83 titulo={`La encargó`} valor={E} />),
      (t[37] = E),
      (t[38] = D));
  let O = (n.asignados ?? []).length > 1 ? `La llevan` : `La lleva`,
    k;
  t[39] === n.asignados
    ? (k = t[40])
    : ((k =
        (n.asignados ?? []).map(US).filter(Boolean).join(`, `) ||
        `Sin asignar`),
      (t[39] = n.asignados),
      (t[40] = k));
  let A;
  t[41] !== O || t[42] !== k
    ? ((A = <Componente_GS_71_83 titulo={O} valor={k} />),
      (t[41] = O),
      (t[42] = k),
      (t[43] = A))
    : (A = t[43]);
  let j;
  t[44] === n.fechaInicio
    ? (j = t[45])
    : ((j = n.fechaInicio ? fS(n.fechaInicio) : `—`),
      (t[44] = n.fechaInicio),
      (t[45] = j));
  let M;
  t[46] === j
    ? (M = t[47])
    : ((M = <Componente_GS_71_83 titulo={`Inicio`} valor={j} />),
      (t[46] = j),
      (t[47] = M));
  let N;
  t[48] === n.fechaVencimiento
    ? (N = t[49])
    : ((N = n.fechaVencimiento ? fS(n.fechaVencimiento) : `—`),
      (t[48] = n.fechaVencimiento),
      (t[49] = N));
  let P;
  t[50] === N
    ? (P = t[51])
    : ((P = <Componente_GS_71_83 titulo={`Vencimiento`} valor={N} />),
      (t[50] = N),
      (t[51] = P));
  let F;
  t[52] === s
    ? (F = t[53])
    : ((F = s && <Componente_GS_71_83 titulo={`Meta`} valor={s.titulo} />),
      (t[52] = s),
      (t[53] = F));
  let I;
  t[54] === l
    ? (I = t[55])
    : ((I = l && <Componente_GS_71_83 titulo={`Lista`} valor={l.nombre} />),
      (t[54] = l),
      (t[55] = I));
  let L;
  t[56] !== f || t[57] !== m
    ? ((L = m > 0 && (
        <Componente_GS_71_83 titulo={`Checklist`} valor={`${f} de ${m}`} />
      )),
      (t[56] = f),
      (t[57] = m),
      (t[58] = L))
    : (L = t[58]);
  let R;
  t[59] === n.completadaEn
    ? (R = t[60])
    : ((R = n.completadaEn && (
        <Componente_GS_71_83
          titulo={`Se completó`}
          valor={pS(n.completadaEn)}
        />
      )),
      (t[59] = n.completadaEn),
      (t[60] = R));
  let z;
  t[61] !== D ||
  t[62] !== A ||
  t[63] !== M ||
  t[64] !== P ||
  t[65] !== F ||
  t[66] !== I ||
  t[67] !== L ||
  t[68] !== R
    ? ((z = (
        <dl
          className={`grid gap-x-4 gap-y-2 sm:grid-cols-2`}
          children={[D, A, M, P, F, I, L, R]}
        />
      )),
      (t[61] = D),
      (t[62] = A),
      (t[63] = M),
      (t[64] = P),
      (t[65] = F),
      (t[66] = I),
      (t[67] = L),
      (t[68] = R),
      (t[69] = z))
    : (z = t[69]);
  let ee;
  t[70] === r
    ? (ee = t[71])
    : ((ee = r.length > 0 && (
        <div
          children={[
            <p className={`text-xs text-(--text)`} children={`Sustento`} />,
            <ul
              className={`mt-1 flex flex-col gap-1`}
              children={r.map(Componente_HS_72_83)}
            />,
          ]}
        />
      )),
      (t[70] = r),
      (t[71] = ee));
  let te;
  return (
    t[72] !== C || t[73] !== w || t[74] !== T || t[75] !== z || t[76] !== ee
      ? ((te = (
          <div
            className={`flex flex-col gap-3 text-sm`}
            children={[C, w, T, z, ee]}
          />
        )),
        (t[72] = C),
        (t[73] = w),
        (t[74] = T),
        (t[75] = z),
        (t[76] = ee),
        (t[77] = te))
      : (te = t[77]),
    te
  );
}
